module.exports = __webpack_public_path__ + "static/media/anarkali old.650484ae.jpg";